import React from 'react';
import PropTypes from 'prop-types';
import ButtonSpinner from '../../components/ButtonSpinner';
import RichSelectField from '../../components/formfields/RichSelectField';

const ClubBillingSelector = ({
  isVisible,
  loading,
  loaded,
  clubs,
  selectedClubId,
  onSelectClub,
  emptyMessage,
  placeholder,
  label
}) => {
  if (!isVisible) {
    return null;
  }

  if (loading) {
    return <ButtonSpinner loading={loading} />;
  }

  if (loaded && clubs?.length === 0) {
    return (
      <p className="text-sm text-gray-500">
        {emptyMessage}
      </p>
    );
  }

  if (clubs?.length > 0) {
    return (
      <div className="mb-5">
        <RichSelectField
          id="club-billing"
          label={label}
          value={selectedClubId}
          valueKey="club_id"
          onChange={(e) => {
            const value = e.target.value;
            const selectedClub = clubs.find(club => club.club_id === value);
            onSelectClub?.(selectedClub);
          }}
          onBlur={(e) => {
            const value = e.target.value;
            const selectedClub = clubs.find(club => club.club_id === value);
            onSelectClub?.(selectedClub);
          }}
          options={clubs}
          formatValue={(option) => ({
            key: option?.club_id,
            icon: null,
            label: option?.name || '',
            value: option?.club_id
          })}
          placeholder={placeholder}
          required
        />
      </div>
    );
  }

  return null;
};

ClubBillingSelector.propTypes = {
  /**
   * Whether this component should be visible (typically tied to active tab)
   */
  isVisible: PropTypes.bool.isRequired,

  /**
   * Whether clubs are currently being loaded
   */
  loading: PropTypes.bool.isRequired,

  /**
   * Whether clubs have been loaded (used to determine empty state)
   */
  loaded: PropTypes.bool.isRequired,

  /**
   * Array of club billing objects
   */
  clubs: PropTypes.arrayOf(
    PropTypes.shape({
      club_id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      account_number: PropTypes.string,
    })
  ),

  /**
   * ID of the currently selected club
   */
  selectedClubId: PropTypes.string,

  /**
   * Callback function when a club is selected
   * @param {Object} club - The selected club object
   */
  onSelectClub: PropTypes.func.isRequired,

  /**
   * Message to display when no clubs are found
   */
  emptyMessage: PropTypes.string,

  /**
   * Placeholder text for the select field
   */
  placeholder: PropTypes.string,

  /**
   * Label for the select field
   */
  label: PropTypes.string,
};

ClubBillingSelector.defaultProps = {
  clubs: [],
  selectedClubId: '',
  emptyMessage: 'No club billing options available.',
  placeholder: 'Club Billing Not Selected',
  label: 'Select Club Billing Option',
};

export default ClubBillingSelector;